import { useDispatch, useSelector } from 'react-redux';

import { useCallback } from 'react';
import useInfoModal from '../../hooks/useInfoModal';
import {
  setInfoModalClose,
  setReviewsModalOpen,
} from '../../redux/ducks/UIDucks';
import { InfoModalActionType } from '../../redux/ducks/UIDucks.types';
import type { RootReducerType } from '../../redux/reducers/RootReducer.types';
import Modal from './Modal';

const getEnumName = (value: InfoModalActionType): string => {
  switch (value) {
    case InfoModalActionType.Text:
      return 'Text';
    default:
      return 'Unknown';
  }
};

const InfoModal = () => {
  const { isOpen } = useInfoModal();
  const dispatch = useDispatch();

  const infoModalProps = useSelector(
    (state: RootReducerType) => state.ui.infoModalProps,
  );

  const bodyContent = (
    <div className="flex min-w-full flex-col">
      <span className="min-w-full text-left text-pretty">
        {infoModalProps?.message}
      </span>
    </div>
  );

  const onPrimary = useCallback(() => {
    if (isOpen) {
      dispatch(setInfoModalClose(true));
    }
  }, [isOpen, dispatch]);

  const onSecondary = useCallback(() => {
    if (isOpen) {
      dispatch(setInfoModalClose(true));
    }
  }, [isOpen, dispatch]);

  return (
    <Modal
      id={`${getEnumName(
        infoModalProps?.action || InfoModalActionType.Unknown,
      )}_info_modal`}
      setIsOpen={(open) => dispatch(setReviewsModalOpen(open))}
      disabled={false}
      loading={false}
      isOpen={isOpen}
      title=""
      actionLabel=""
      actionType="neutral"
      secondaryActionLabel={''}
      secondaryAction={onSecondary}
      onClose={onSecondary}
      onSubmit={onPrimary}
      body={bodyContent}
      noFit
      isInfo
    />
  );
};

export default InfoModal;
